export default{
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async create ({commit}, card) {
      return this.$api.createCard(card)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/cards.js